import ajax from "@/lib/ajax";

import Ajax from '../../lib/ajax'
//新增或是更新排队叫号格式
export async function CreateOrUpdateQueueNumberTemp(payload:any) {
	let res = await Ajax.post(`/api/services/app/QueueNumber/CreateOrUpdateQueueNumberTemp`, payload)
	return res.data.result
}
//获取排队叫号序列
export async function GetQueueNumber(payload:any) {
	let res = await Ajax.get(`/api/services/app/QueueNumber/GetQueueNumber`, {params:payload})
	return res.data.result
}
//获取排队叫号序列模板
export async function GetQueueNumberTemp(payload:any) {
	let res = await Ajax.get(`/api/services/app/QueueNumber/GetQueueNumberTemp`, {params:payload})
	return res.data.result
}
//新增或是更新排队叫号格式
export async function UpdateQueueNumber(payload:any) {
	let res = await Ajax.put(`/api/services/app/QueueNumber/UpdateQueueNumber`, payload)
	return res.data.result
}


// WEBPACK FOOTER //
// ./src/api/queuingUp/index.ts